export default __webpack_public_path__ + "static/media/header.236f03c1.png";